<template>
    <div id="weachetPay">
        <div class="weachetPay-top">
            <p>扫一扫付款（元）</p>
            <p>￥{{totalAmount}}</p>
        </div>
        <div class="weachetPay-bottom">
            <div class="bottom-left">
                <div class="left-top">
                    <img :src="imgData" alt="">
                </div>
                <div class="left-bottom">
                    <p><i></i></p>
                    <div class="left-bottom-right">
                        <p>打开手机微信</p>
                        <p>扫一扫进行付款</p>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

    export default {
        name: "weachetPay",
        props:{
            imgData:{
                type:String
            },
            orderId:{

            },
            totalAmount:{

            },
        },
        methods:{
            closeModal(){
                this.$emit('closeModal')
            },

        },
        created() {

        }

    }
</script>

<style scoped lang="scss">
    #weachetPay{
        .weachetPay-top{
            padding-left:0.8rem;
            p{
                font-size: 0.16rem;
                line-height:0.3rem ;
                color:#212121;
                &:last-of-type{
                    color: #F5222D;
                    font-weight: bold;
                    font-size: 0.32rem;
                    padding-left:0.2rem;
                }
            }
        }
        .weachetPay-bottom{
            text-align: center;
            margin-top: 0.1rem;
            padding:0 0.3rem;
            >div{
                display: inline-block;
                vertical-align: middle;
            }
        }
        .left-bottom{
            padding:0.1rem 0;
            >p{
                line-height: 0.4rem;
                height: 0.4rem;
                display: inline-block;
                width: 0.5rem;
                text-align: right;
                padding-right: 0.05rem;
                i{
                    /*margin-top: 0.1rem;*/
                    display: inline-block;
                    width: 0.4rem;
                    height: 0.4rem;
                    background: url('../../../../../assets/images/pay_saoyisao.png') no-repeat center;
                    background-size: contain;
                }
            }
        }
        .left-bottom-right{
            display: inline-block;
            p{
                color:#212121;
                font-size: 0.16rem;
                /*line-height: 0.3rem;*/
            }
        }
        .bottom-left{
            margin: 0 auto;
            width: 2.1rem;
            padding:0.05rem;
            background: #EFF3F6;
            img{
                max-width:1.8rem;
                max-height:1.8rem;
            }
        }
    }
</style>